import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  forwardRef,
  input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MonthDayDatepickerForm } from '../../../types/month-day-datepicker.form';

@Component({
  selector: 'qaroni-month-day-datepicker',
  templateUrl: './month-day-datepicker.component.html',
  styleUrl: './month-day-datepicker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MonthDayDatepickerComponent),
      multi: true,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: { ...MAT_DATE_FNS_FORMATS.parse, dateInput: 'dd MMMM' },
        display: { ...MAT_DATE_FNS_FORMATS.display, dateInput: 'dd MMMM' },
      },
    },
  ],
  standalone: false,
})
export class MonthDayDatepickerComponent
  extends MonthDayDatepickerForm
  implements OnInit, ControlValueAccessor
{
  readonly label = input<string>(null);

  private onChange: (value: Date | null) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit(): void {
    this.subs.add(
      this.date.valueChanges.subscribe(date => this.onChange(date))
    );
  }

  writeValue(value: Date | null): void {
    this.date.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: (value: Date | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.date.disable({ emitEvent: false });
    } else {
      this.date.enable({ emitEvent: false });
    }
  }

  onBlur(): void {
    this.onTouched();
  }
}
